import React, {useState, useEffect} from "react";
import descargar from "../../../assets/images/icons/shared/Descargar.svg"
import PdfBackground from "./pdfBackground";
import { toggleManualVisibility } from "../../../client/manuals";
import ContentLoader from "react-content-loader";

const PdfCard = ({ 
  pdfFile, 
  title, 
  onViewClick, 
  onDownloadClick,
  adminMode = false,
  onEditClick,
  onDeleteClick,
  manualId, 
  initialVisible,
  isLoaded,
  onVisibilityChange,
}) => {

  const [isVisible, setIsVisible] = useState(initialVisible);
  const [isLoading, setIsLoading] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false); 
  const [isPdfLoaded, setIsPdfLoaded] = useState(false); 

  useEffect(() => {
    if (isLoaded) {
      setIsPdfLoaded(true);
    } else {
      setIsPdfLoaded(false);
    }
  }, [isLoaded, pdfFile]);

  const handleVisibilityToggle = async () => {
    try {
      setIsLoading(true);
      const response = await toggleManualVisibility(manualId);
      
      if (response.data && response.data.visible !== undefined) {
        const newVisibility = response.data.visible;
        setIsVisible(newVisibility);
        
        if (onVisibilityChange) {
          onVisibilityChange(newVisibility, title);
        }
      }
    } catch (error) {
      console.error("Error al cambiar visibilidad:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownload = async () => {
    if (isDownloading) return; 
    
    setIsDownloading(true);
    try {
      await onDownloadClick(manualId, title);
    } catch (error) {
      console.error("Error en descarga:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center gap-3">
      {!isPdfLoaded && (
        <div className="relative overflow-hidden drop-shadow-manual rounded-lg h-[320px] w-[230px]">
          <ContentLoader 
            speed={2}
            width={230}
            height={320}
            viewBox="0 0 230 320"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
          >
            <rect x="0" y="0" rx="8" ry="8" width="230" height="320" />
          </ContentLoader>
        </div>
      )}


      <div className={`${isPdfLoaded ? 'block' : 'hidden'}`}>
        <div className="relative overflow-hidden drop-shadow-manual p-2 rounded-lg h-[320px] w-[230px]">
          <div className="inset-0 flex items-center justify-center w-full h-full">
          <PdfBackground
           pdfFile={pdfFile} onLoadComplete={() => setIsPdfLoaded(true)}/>
          </div>

          <div className="absolute inset-0 flex justify-center items-center h-[320px] w-[230px] bg-opacity-50 p-3 bg-[#184A7D80] rounded-lg ">
            <div className="flex flex-col   justify-center items-center h-[320px] w-[230px] font-itcbold gap-8 text-center text-[18px] text-white">
              <p className="break-words px-1 max-w-[230px] drop-shadow-[0_2px_4px_rgba(0,0,0,0.25)]">
                {title}
              </p>
              {adminMode ? (
              <div className="flex items-start justify-center w-full">
                <div className="grid w-[108px] items-center justify-center grid-cols-3 p-1 py-2 divide-x divide-white rounded-lg bg-blue">
                  <button 
                      onClick={handleVisibilityToggle}
                      disabled={isLoading}
                      className="flex justify-center p-1">
                      {isLoading ? (
                        <svg className="w-5 h-5 text-white animate-spin" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                      ) : isVisible ? (
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0.886719 8.75C1.59172 4.91 4.95622 2 9.00022 2C13.0442 2 16.4087 4.91 17.1145 8.75C16.4095 12.59 13.0442 15.5 9.00022 15.5C4.95622 15.5 1.59172 12.59 0.886719 8.75ZM9.00022 12.5C9.99478 12.5 10.9486 12.1049 11.6519 11.4017C12.3551 10.6984 12.7502 9.74456 12.7502 8.75C12.7502 7.75544 12.3551 6.80161 11.6519 6.09835C10.9486 5.39509 9.99478 5 9.00022 5C8.00566 5 7.05183 5.39509 6.34857 6.09835C5.64531 6.80161 5.25022 7.75544 5.25022 8.75C5.25022 9.74456 5.64531 10.6984 6.34857 11.4017C7.05183 12.1049 8.00566 12.5 9.00022 12.5ZM9.00022 11C8.40348 11 7.83118 10.7629 7.40923 10.341C6.98727 9.91903 6.75022 9.34674 6.75022 8.75C6.75022 8.15326 6.98727 7.58097 7.40923 7.15901C7.83118 6.73705 8.40348 6.5 9.00022 6.5C9.59696 6.5 10.1693 6.73705 10.5912 7.15901C11.0132 7.58097 11.2502 8.15326 11.2502 8.75C11.2502 9.34674 11.0132 9.91903 10.5912 10.341C10.1693 10.7629 9.59696 11 9.00022 11Z" fill="white"/>
                        </svg>
                      ) : (
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3.39022 4.45116L1.04572 2.10591L2.10622 1.04541L16.9555 15.8939L15.895 16.9552L13.4125 14.4727C12.0931 15.3094 10.5625 15.7525 9.00022 15.7499C4.95622 15.7499 1.59172 12.8399 0.886719 8.99991C1.20991 7.25374 2.0879 5.65845 3.39022 4.45116ZM11.0687 12.1289L9.97072 11.0309C9.55075 11.2318 9.0788 11.2976 8.61992 11.219C8.16103 11.1404 7.73782 10.9215 7.40862 10.5923C7.07942 10.2631 6.86045 9.83984 6.78188 9.38096C6.70332 8.92208 6.76903 8.45012 6.96997 8.03016L5.87197 6.93216C5.39476 7.65328 5.18142 8.51716 5.26809 9.37753C5.35476 10.2379 5.73611 11.0419 6.34756 11.6533C6.95901 12.2648 7.76298 12.6461 8.62335 12.7328C9.48372 12.8195 10.3476 12.6061 11.0687 12.1289ZM5.98072 2.81991C6.91597 2.45241 7.93522 2.24991 9.00022 2.24991C13.0442 2.24991 16.4087 5.15991 17.1145 8.99991C16.8847 10.2494 16.3681 11.4286 15.6055 12.4447L12.7105 9.54966C12.737 9.36966 12.7502 9.18641 12.7502 8.99991C12.7503 8.46099 12.6342 7.92839 12.4099 7.43838C12.1856 6.94836 11.8583 6.51245 11.4503 6.16035C11.0424 5.80824 10.5633 5.5482 10.0457 5.39795C9.52818 5.2477 8.98433 5.21076 8.45122 5.28966L5.98072 2.81991Z" fill="white"/>
                        </svg>
                      )}
                  </button>
    
                  <button onClick={onEditClick} className="flex justify-center p-1">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 21.2852C3.71667 21.2852 3.47933 21.1892 3.288 20.9972C3.09667 20.8052 3.00067 20.5678 3 20.2852V17.8602C3 17.5935 3.05 17.3392 3.15 17.0972C3.25 16.8552 3.39167 16.6428 3.575 16.4602L16.2 3.86016C16.4 3.67682 16.621 3.53516 16.863 3.43516C17.105 3.33516 17.359 3.28516 17.625 3.28516C17.891 3.28516 18.1493 3.33516 18.4 3.43516C18.6507 3.53516 18.8673 3.68516 19.05 3.88516L20.425 5.28516C20.625 5.46849 20.7707 5.68516 20.862 5.93516C20.9533 6.18516 20.9993 6.43516 21 6.68516C21 6.95182 20.954 7.20616 20.862 7.44816C20.77 7.69016 20.6243 7.91082 20.425 8.11016L7.825 20.7102C7.64167 20.8935 7.429 21.0352 7.187 21.1352C6.945 21.2352 6.691 21.2852 6.425 21.2852H4ZM17.6 8.08516L19 6.68516L17.6 5.28516L16.2 6.68516L17.6 8.08516Z" fill="white"/>
                      </svg>
                  </button>
    
                  <button onClick={onDeleteClick} className="flex justify-center p-1">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.241 4.00616L15.534 6.03516H19.5C19.6989 6.03516 19.8897 6.11417 20.0303 6.25483C20.171 6.39548 20.25 6.58624 20.25 6.78516C20.25 6.98407 20.171 7.17483 20.0303 7.31549C19.8897 7.45614 19.6989 7.53516 19.5 7.53516H18.731L17.858 17.7202C17.805 18.3402 17.762 18.8502 17.693 19.2622C17.623 19.6912 17.516 20.0752 17.307 20.4312C16.9788 20.9903 16.4909 21.4385 15.906 21.7182C15.534 21.8952 15.142 21.9682 14.708 22.0022C14.291 22.0352 13.78 22.0352 13.158 22.0352H10.842C10.22 22.0352 9.709 22.0352 9.292 22.0022C8.858 21.9682 8.466 21.8952 8.094 21.7182C7.50908 21.4385 7.02118 20.9903 6.693 20.4312C6.483 20.0752 6.378 19.6912 6.307 19.2622C6.238 18.8492 6.195 18.3402 6.142 17.7202L5.269 7.53516H4.5C4.30109 7.53516 4.11032 7.45614 3.96967 7.31549C3.82902 7.17483 3.75 6.98407 3.75 6.78516C3.75 6.58624 3.82902 6.39548 3.96967 6.25483C4.11032 6.11417 4.30109 6.03516 4.5 6.03516H8.466L8.759 4.00616L8.77 3.94516C8.952 3.15516 9.63 2.53516 10.48 2.53516H13.52C14.37 2.53516 15.048 3.15516 15.23 3.94516L15.241 4.00616ZM9.981 6.03516H14.018L13.762 4.25916C13.714 4.09216 13.592 4.03516 13.519 4.03516H10.481C10.408 4.03516 10.286 4.09216 10.238 4.25916L9.981 6.03516ZM11.25 10.7852C11.25 10.5862 11.171 10.3955 11.0303 10.2548C10.8897 10.1142 10.6989 10.0352 10.5 10.0352C10.3011 10.0352 10.1103 10.1142 9.96967 10.2548C9.82902 10.3955 9.75 10.5862 9.75 10.7852V15.7852C9.75 15.9841 9.82902 16.1748 9.96967 16.3155C10.1103 16.4561 10.3011 16.5352 10.5 16.5352C10.6989 16.5352 10.8897 16.4561 11.0303 16.3155C11.171 16.1748 11.25 15.9841 11.25 15.7852V10.7852ZM14.25 10.7852C14.25 10.5862 14.171 10.3955 14.0303 10.2548C13.8897 10.1142 13.6989 10.0352 13.5 10.0352C13.3011 10.0352 13.1103 10.1142 12.9697 10.2548C12.829 10.3955 12.75 10.5862 12.75 10.7852V15.7852C12.75 15.9841 12.829 16.1748 12.9697 16.3155C13.1103 16.4561 13.3011 16.5352 13.5 16.5352C13.6989 16.5352 13.8897 16.4561 14.0303 16.3155C14.171 16.1748 14.25 15.9841 14.25 15.7852V10.7852Z" fill="white"/>
                      </svg>
                  </button>
                </div>
              </div>
              ) : (
              <button
                onClick={onViewClick} 
                className="underline transition-colors"
              >
                  Ver
              </button>
              )}
            </div>
          </div>
        </div>
</div>
      {adminMode  && (
      <p
        onClick={onViewClick}  
        className="text-sm text-center cursor-pointer text-blue-btn hover:underline"
      >
        Ver documento
      </p>
      )}

      {!adminMode && (
      <div 
        className="flex items-center justify-center gap-2 cursor-pointer hover:text-blue"
        onClick={handleDownload}
        disabled={isDownloading}
      >
        {isDownloading ? (
          <>
            <p className="font-rubikmedium text-[14px] text-[#6B7280]">Descargando...</p>
            <svg className="w-4 h-4 text-blue animate-spin" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 极狐 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          </>
        ) : (
          <>
            <p className="font-rubikmedium hover:underline text-[14px] text-[#6B7280]">Descargar</p>
            <img src={descargar} alt="Descargar" className="w-4 h-4" />
          </>
        )}
      </div>
      )}

    </div>
  );
};

export default PdfCard;